export const ACCEPTABLE_FILE_TYPES = [
	'pdf',
	'png',
	'jpg',
	'jpeg',
	'JPG',
	'PNG',
	'JPEG',
	'PDF',
];
